module.exports = __webpack_public_path__ + "media/images/silicon-label-5ec3a1935c9bf3612ac9bb1d94cdaec1.png";